import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Form, Button, Alert, PageHeader, Divider } from "antd";
import { FormInstance } from "antd/lib/form";
import message from 'antd/lib/message'
import { AlertProps } from "antd/lib/alert";
import { mapFormItemToProps, randomString } from 'src/utils'
import * as sourceData  from 'src/data'
import {FormItemContent, FormItem} from 'src/components/FormItem'
import Container from 'src/components/Container'
import Services from 'src/services'
import { useRequest } from 'src/hooks';
import { useSearchParam } from 'react-use';

const formItems = sourceData.networkIosAttributes

const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};
const tailLayout = {
    wrapperCol: { offset: 6, span: 18 },
};


export function Ios(props: any) {
    const { action } = props
    const { id } = useParams<any>()
    const isCopy = action === 'copy'
    const isEdit = !!id

    const [lock, setLock] = React.useState(isEdit && !isCopy)
    
    const requestUpdate = useRequest(Services.iosNetwork.update)
    const requestAdd = useRequest(Services.iosNetwork.add)
    const requestList = useRequest(Services.iosNetwork.list)

    const sdkId = useSearchParam('sdk_id')
    const sdkVersion = useSearchParam('sdk_version')

    const [formRef] = React.useState(React.createRef<FormInstance>());
    const history = useHistory();

    const [loading, setLoading] = React.useState<boolean>(false)
    const [alert, setAlert] = React.useState<AlertProps>()

    const toList = () => history.goBack()

    const onFinish = (values: any) => {
        console.log(JSON.stringify(values, null, 4));

        values.adTypes = values.adTypes.join(',')
        
        setLoading(true)
        if(id && !isCopy) {
            requestUpdate({
                    ...values,
                    adNetworkId: id
                })
                .then(() => {
                    message.success('保存成功')
                    toList()
                })
                .catch((e: AxiosResponse) => {
                    // setAlert({
                    //     type: 'error',
                    //     message: '错误',
                    //     description: e.data.msg
                    // })
                })
                .finally(() => {
                    setLoading(false)
                })
        } else {
            requestAdd({
                    ...values,
                })
                .then(() => {
                    message.success('新建成功')
                    toList()
                })
                .catch((e: AxiosResponse) => {
                    // setAlert({
                    //     type: 'error',
                    //     message: '错误',
                    //     description: e.data.msg
                    // })
                })
                .finally(() => {
                    setLoading(false)
                })
        }
        
    };

    const onFill = (data: any) => {
        if(data === undefined) {
            data = {
                ...formItems.reduce<any>((memo, item) => {
                    memo[item.key] = randomString(16, item.key + '-')
                    return memo
                }, {})
            }
        }
        formRef.current?.setFieldsValue(data);
    }

    const [ versionName, setVersionName ] = React.useState<string>('')
    const [originData, setOriginData] = React.useState<any>({})
    const setData = (res: any[]) => {
        if(!res.length || res.length !== 1) {
            return setAlert({
                type: 'error',
                message: '出错',
                description: '返回数据错误'
            })
        }

        const data = res[0]
        setVersionName(data.adNetworkVersionName)
        data.adTypes = data.adTypes.split(',')

        setOriginData(Object.assign({}, data))

        if(isCopy) {
            // data.adNetworkVersionName = ''
            // data.nameEn = ''
            // data.nameCn = ''
        }

        // if(sdkId) {
        //     data.sdkId = sdkId
        // }

        onFill(data)
    }

    React.useEffect(() => {
        if(id) {
            setLoading(true)
            requestList({adNetworkId: id})
                .then(setData)
                .finally(() => {
                    setLoading(false)
                })
        } else {
            onFill({sdkId})
            formRef.current?.setFieldsValue({isHeaderBidding: '0'})
        }
    }, [id])

    let pageTitle: string = ''
    if(isCopy) {
        pageTitle = `复制iOS SDK ${sdkVersion} - 广告网络 ${versionName}`
    } else if(!!id) {
        pageTitle = `编辑iOS SDK ${sdkVersion} - 广告网络 ${versionName}`
    } else {
        pageTitle = `新建iOS SDK ${sdkVersion} - 广告网络`
    }

    return (
    <div>
        <PageHeader
            onBack={toList}
            title={pageTitle}
        ></PageHeader>

        {alert && <Alert {...alert}/>}

        <Container loading={loading}>
            <Divider orientation="left" plain>
                基本信息
            </Divider>
    
            <Form {...layout} ref={formRef} name="control-ref" onFinish={onFinish}>
                {
                    formItems
                        .map(mapFormItemToProps)
                        .map(({
                            formItemProps,
                            formItemContentProps
                        }: any) => {
                            const {key} = formItemProps
                            // if(formItemProps.name === 'nameCn') {
                            //     formItemProps.rules = []
                            // }
                            if(lock) {
                                formItemContentProps.disabled = true
                            }

                            return (
                                <FormItem defaultValue={originData[key]}  {...formItemProps}>
                                    <FormItemContent {...formItemContentProps} />
                                </FormItem>
                            )
                        })
                }
                <Form.Item {...tailLayout}>
                    {lock ? (
                        <Button type="primary" size="large" 
                            onClick={(e) => {
                                setLock(false)
                                e.preventDefault()
                            }} 
                            htmlType="button"
                        >
                            编辑
                        </Button>
                    ) : (
                        <Button type="primary" loading={loading} size="large" htmlType="submit">
                            提交
                        </Button>
                    )}
                    <Button size="large" htmlType="button" onClick={toList}>
                        返回
                    </Button>
                    {/* <Button type="link" htmlType="button" onClick={onFill}>
                        Fill form
                    </Button> */}
                </Form.Item>
            </Form>
        </Container>
    </div>
    );
}
